/**
 * @module router/modules/settlement
 * @description 정산 도메인 라우트 모듈 — 고객사 정산, 수리파트너 정산,
 * 정산 확정 관리/상세, 정산 주기 관리 페이지 경로를 정의합니다.
 * 정산 확정 관리·상세·주기 관리는 ADMIN 전용이다 — cs-back SettlementAccessChecker 와 같은 기준 (SURINP-692).
 */
const routes = [
  {
    path: '/settlement-clients',
    name: '고객사 정산',
    component: () => import(/* webpackChunkName: "settlementClients" */ '../../views/settlement/SettlementClients.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/settlement-partners',
    name: '수리파트너 정산',
    component: () => import(/* webpackChunkName: "settlementPartners" */ '../../views/settlement/SettlementPartners.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/settlement-management',
    name: '정산 확정 관리',
    component: () => import(/* webpackChunkName: "settlementManagement" */ '../../views/settlement/SettlementManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, roles: ['ADMIN'] }
  },
  {
    path: '/settlement-management/:settlementId',
    name: '정산 확정 상세',
    component: () => import(/* webpackChunkName: "settlementManagementDetail" */ '../../views/settlement/SettlementManagementDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, roles: ['ADMIN'] }
  },
  {
    path: '/settlement-periods',
    name: '정산 주기 관리',
    component: () => import(/* webpackChunkName: "settlementPeriods" */ '../../views/settlement/SettlementPeriodManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, roles: ['ADMIN'] }
  }
]

export default routes
